/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019-2020 (original work) Open Assessment Technologies SA ;
 */

import { router, routingTable } from '@/core';
import { locale } from '@/services/localeService';
import '@oat-sa-private/ui-identity/css/main.css';
import packageJson from '../package.json';
import { extractSubdomain, log } from './core/utils';
import { user } from '@/stores/auth.store.js';
import { configurationStore, currentTenantStore } from './stores/tenantConfiguration.store';
import { storeTokens } from '@/services/authService';
import config from '@/config';
import './locale/beMessages';
import './index.css';

window.__VERSION = packageJson.version;

async function startApplication() {
    locale.setDictionaryLoader();

    try {
        const subdomain = extractSubdomain(window.location.href);
        const currentTenant = config.tenants.find(tenant => tenant.subdomain === subdomain);

        if (!currentTenant) {
            throw new Error("Couldn't retrieve tenant from subdomain");
        }
        currentTenantStore.set(currentTenant);
    } catch (err) {
        log.warn(err.message);
    }

    try {
        await configurationStore.updateConfigurationData();
    } catch (err) {
        log.warn("Couldn't fetch tenant configuration:", err.message);
    }

    if (window.SESSION_OVERRIDE) {
        await storeTokens(window.SESSION_OVERRIDE);
        log.warn('Session overridden', window.SESSION_OVERRIDE);
    }

    try {
        await user.updateInfo(); // throws error if token does not exist
        let { locale: defaultLocale } = configurationStore.get() || {};
        const { language: userLanguage } = user.get() || {};

        await locale.updateApplicationLocale(userLanguage || defaultLocale || '');
        if (user.get()?.userId) {
            await configurationStore.updateTenantRoles();
        }
    } catch (err) {
        log.warn(err.message);
    } finally {
        await router.start(routingTable, window.SESSION_OVERRIDE?.url);
    }
}

startApplication();
